import { Box, Typography } from '@mui/material';

const LinkedFirmCard = ({ fields }) => {
  if (!fields?.length) return null;

  return (
    <Box
      sx={{
        flex: 1,
        bgcolor: 'background.default',
        borderRadius: 2,
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        minWidth:{xs: '85%', sm: 'auto'}
      }}
    >
      {fields.map((field, idx) => (
        <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="labelD" color="text.secondary" sx={{ flex: 1, minWidth: 0 }}>
            {field.display_name}
          </Typography>
          <Typography variant="body1" sx={{ flexShrink: 0, textAlign: 'right', whiteSpace: 'nowrap' }}>
            {field.display_value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default LinkedFirmCard;
